// extracted by mini-css-extract-plugin
export default {"similar_title":"SimilarListings_similar_title__rRXor","gradient_line":"SimilarListings_gradient_line__6FVV3"};